import React from 'react';
import {
  Grid,
  Row,
} from 'react-bootstrap';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';

import TimesheetOverviewEnhanced from './TimesheetOverviewEnhanced';
import TimesheetDetailsEnhanced from './TimesheetDetailsEnhanced';

const propTypes = exact({
  selectedTimesheetKey: PropTypes.string,
});

const TimesheetSummary = (props) => {
  const { selectedTimesheetKey } = props;

  return (
    <div>
      <Grid fluid>
        <Row>
          {selectedTimesheetKey ? (
            <TimesheetOverviewEnhanced />
          ) : (
            'Select a Timesheet'
          )}
        </Row>
        <Row>
          {selectedTimesheetKey ? (
            <TimesheetDetailsEnhanced />
          ) : (''
          )}
        </Row>
      </Grid>
    </div>
  );
};

TimesheetSummary.propTypes = propTypes;

export default TimesheetSummary;
